import { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../../services/authService';
import AuthShell from '../../components/AuthShell/AuthShell';
import styles from '../../components/AuthShell/authForm.module.css';

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email.trim()) { setError('Please enter your email address.'); return; }
        setError('');
        setLoading(true);
        try {
            await forgotPassword(email.trim());
        } catch {
            // Show success regardless to avoid leaking user existence
        } finally {
            setLoading(false);
            setSubmitted(true);
        }
    };

    return (
        <AuthShell
            mode="forgot"
            title="Forgot password?"
            subtitle={submitted ? undefined : "Enter the email address for your account and we'll send you a reset link."}
            pageTitle="Reset your password · Aluvo"
            compact
            clarityMask
            footer={
                <p className={styles.switchText}>
                    {submitted ? (
                        <Link to="/login" className={styles.link}>Back to Sign In</Link>
                    ) : (
                        <>
                            Remembered it?{' '}
                            <Link to="/login" className={styles.link}>Sign In</Link>
                        </>
                    )}
                </p>
            }
        >
            {submitted ? (
                <p className={styles.infoMsg} role="status">
                    If an account exists for <strong>{email}</strong>, you'll receive a password reset link shortly. Check your inbox (and spam folder).
                </p>
            ) : (
                <form className={styles.form} onSubmit={handleSubmit} noValidate aria-label="Request password reset">
                    <div className={styles.field}>
                        <label htmlFor="forgot-email" className={styles.srOnly}>Email address</label>
                        <input
                            id="forgot-email"
                            className={`${styles.input} ${error ? styles.inputError : ''}`}
                            type="email"
                            placeholder="Email address"
                            value={email}
                            onChange={(e) => { setEmail(e.target.value); setError(''); }}
                            autoComplete="email"
                            autoCapitalize="none"
                            aria-invalid={error ? 'true' : undefined}
                            aria-describedby={error ? 'forgot-email-error' : undefined}
                        />
                        {error && <span id="forgot-email-error" className={styles.fieldError} role="alert">{error}</span>}
                    </div>
                    <button className={styles.btnPrimary} type="submit" disabled={loading} aria-busy={loading || undefined}>
                        {loading ? <span className={styles.spinner} aria-label="Sending" /> : 'Send Reset Link'}
                    </button>
                </form>
            )}
        </AuthShell>
    );
}
